// extracted by mini-css-extract-plugin
module.exports = {"ModbusWrapper":"EditDevice_ModbusWrapper__v6xGl","Title":"EditDevice_Title__2ABJh"};